import Vue from "vue";
import Router from "vue-router";

import Layout from "@/Layouts/index.vue";

import CheckForReload from "@lab/utils/reloader";
import Dashboard from "@/views/Dashboard/index.vue";

// Profile routes
import { profile } from "@shared/routes/user.profile";
// We need to set the components layout
profile.component = Layout;

import BookingRoutes from "./routes/bookings";
import DataMapRoutes from "./routes/data.maps";
import FacilityRoomRoutes from "./routes/facility.rooms";
import FacilityRoutes from "./routes/facility";
import FacilityVacancyRoutes from "./routes/facility.vacancies";
import HealthServiceRoutes from "./routes/health.services";
import HomeCareRoutes from "./routes/homecare";
import HospitalRoutes from "./routes/hospitals";
import OrganisationRoutes from "./routes/organisations";
import ReportRoutes from "./routes/reports";
import UserRoutes from "./routes/user";

Vue.use(Router);

const routes = [
	profile,
	{
		path: "/",
		component: Layout,
		name: "home",
		children: [
			{
				path: "dashboard",
				alias: "",
				name: "Dashboard",
				component: Dashboard
			},
			...BookingRoutes,
			...DataMapRoutes,
			...FacilityRoomRoutes,
			...FacilityRoutes,
			...FacilityVacancyRoutes,
			...HealthServiceRoutes,
			...HomeCareRoutes,
			...HospitalRoutes,
			...OrganisationRoutes,
			...ReportRoutes,
			...UserRoutes
		]
	}
];

const router = new Router({
	mode: "history",
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		} else {
			return {
				x: 0,
				y: 0
			};
		}
	},
	routes
});

function isLoggedIn() {
	if (window.localStorage) {
		return !!window.localStorage.getItem("token");
	}
	return false;
}

// Some middleware to help us ensure the user is authenticated.
// Put noAuth: true on only route that doesn't require auth
router.beforeEach((to, from, next) => {
	// If they aren't logged in then, redirect to /login and set query for redirect
	const noAuth = to && to.meta && to.meta.noAuth;
	// For some reason we are getting a double redirect to the login page.
	const isLoginPage = to.name === "Login";

	if (!isLoginPage && !noAuth && !isLoggedIn()) {
		// IE/Edge fix. They are setting the no / path to be '/undefined'
		const nextPath = to.fullPath === "/undefined" ? undefined : to.fullPath;
		next({
			path: "/login",
			query: {
				redirect: nextPath
			}
		});
	} else {
		CheckForReload();
		if (to.meta.title) {
			document.title = to.meta.title;
		} else {
			document.title = `DailyAdmin`;
		}
		next();
	}
	window.scrollTo(0, 0);
});

router.afterEach((to) => {
	(window as any).dataLayer = (window as any).dataLayer || [];
	const { name, path, params } = to;
	(window as any).dataLayer.push({
		event: "pageview",
		name,
		path,
		params,
		dnt: navigator.doNotTrack
	});
});

export default router;
